import React from "react";
import I18n from "i18n-js";

const NoData = () => {
  return <div className="text-muted text-center bg-light border border-secondary px-2 py-1 rounded-pill" style={{ width: "fit-content", fontSize: "14px" }}>{I18n.t("common.blank")}</div>;
};

export default NoData;